import Properties from "@/pages/Properties";

export default function NewLet() {
  return <Properties />;
}
